export default {
  Draft: "Draft",
  Submitted: "Submitted",
  SentToSupplierSignatory: "SentToSupplierSignatory",
  SentToIpsSignatory: "SentToIpsSignatory",
  DealRejected: "DealRejected",
  IpsApproved: "IpsApproved",
  Live: "Live",
  Retired: "Retired",
};
